module.exports = __webpack_public_path__ + "img/geod_2.6507e61c.jpg";